import React from 'react';
import Highlight from 'react-scale/components/ui/highlight';
import TaskResponseVideoClassification from '../tasks/TaskResponseVideoClassification';

export const instruction = 'Classify using the following attributes.';

export const responseCode = `{
  "annotations": {
    "url": "https://scaleapi-results.s3.us-west-1.amazonaws.com/4b7c4bd0-b1ee-11e8-b472-b39f604468d8",
  },
}`;

export const code = `client.createCategorizationTask(
  {
    callback_url: 'http://www.example.com/callback',
    instruction: '${instruction}',
    attachment_type: 'video',
    attachment: 'http://example.com/video.mp4',
    taxonomies: {
      category: {
        type: 'category',
        description: 'Video Category',
        choices: ['Sport', 'Lifestyle', 'Drama']
      },
      adventure-genre: {
        type: 'category',
        description: 'What sub-category of lifestyle does it belong to?',
        choices: ['Cooking', 'Fashion', 'Arts & Crafts'],
        condition: {
          taxonomy: 'category',
          choices: ['Lifestyle']
        }
      },
    }
  },
  (err, task) => {
    // do something with task
  }
);`;

export const response = (
  <div className="data-collection">
    <Highlight className="javascript" key="highlight-json">
      {responseCode}
    </Highlight>
  </div>
);

const component = ({ refAsync }) => <TaskResponseVideoClassification ref={refAsync} />;

export const example = { component };

export const result = null;
